export const ExternalLinkStateFields = {
  TYPE: 'type',
  TOKEN: 'token',
  TENANT: 'tenant',
  POLL_ID: 'pollId',
  USER_ID: 'userId',
  SIGNATURE: 'signature',
  NOTIFIER_TYPE: 'notifierType',
  USER_SELECTION: 'userSelection',
};

export const ExternalLinkTypes = {
  POLL_VOTE: 'pollVote',
  SET_PASSWORD: 'setPassword',
  EDIT_APPLICATION: 'editApplication',
  CREATE_APPLICATION: 'createApplication',
  EDIT_SHARED_ACCOUNT: 'editSharedAccount',
  CREATE_SHARED_ACCOUNT: 'createSharedAccount',
  CREATE_TICKETING_INTEGRATION: 'createTicketingIntegration',
};

export const TokenValidationExcludedLinkTypes = [ExternalLinkTypes.POLL_VOTE];

export const ExternalLinkPollVoteFields = {
  I_KNOW_THIS_APPLICATION: 'i_know_this_application',
  I_DONT_KNOW_THIS_APPLICATION: 'i_dont_know_this_application',
};
